"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _type = require("./type.js");
// @ts-check

/**
 * @param {SimplePosType} domInfo
 * @param {[number, number]} moveXY
 * @returns {SimplePosType}
 */
var getAfterMove = function getAfterMove(domInfo, moveXY) {
  var width = domInfo.right - domInfo.left;
  var height = domInfo.bottom - domInfo.top;
  var info = {
    top: moveXY[1],
    right: moveXY[0] + width,
    bottom: moveXY[1] + height,
    left: moveXY[0]
  };
  return info;
};
var _default = exports["default"] = getAfterMove;
module.exports = exports.default;